var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useSpring } from "@react-spring/web";
import { size } from "lodash";
export var useSpringValues = function (props) {
  var springConfig = props.springConfig,
    delay = props.delay,
    animate = props.animate,
    _a = props.from,
    from = _a === void 0 ? {} : _a,
    _b = props.to,
    to = _b === void 0 ? {} : _b,
    rest = __rest(props, ["springConfig", "delay", "animate", "from", "to"]);
  var toValues = __assign(__assign({}, to), rest);
  var fromValues = __assign(__assign({}, toValues), from);
  var springValues = useSpring({
    from: fromValues,
    to: toValues,
    config: springConfig,
    delay: delay
  });
  return (animate === undefined ? !!size(from) : animate) ? springValues : toValues;
};